import { gql } from 'apollo-angular';
import { workspaceUserItemFragment } from '../user/user.fragments';

export const cardTaskDetailFragment = gql`
  fragment CardTaskDetail on CardTask {
    id
    createdAt
    archivedAt
    completedAt
    endDate
    order
    cardTaskStatus
    title
    users {
      nodes {
        ...WorkspaceUserItem
      }
    }
  }
  ${workspaceUserItemFragment}
`;
